import { render, staticRenderFns } from "./complete-order.vue?vue&type=template&id=2fa196d5&scoped=true"
import script from "./complete-order.vue?vue&type=script&lang=js"
export * from "./complete-order.vue?vue&type=script&lang=js"
import style0 from "./complete-order.vue?vue&type=style&index=0&id=2fa196d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa196d5",
  null
  
)

export default component.exports